export function formatOptions(dataArray, labelKey, valueKey) {
  if (!Array.isArray(dataArray)) return [];

  return dataArray
    .filter((item) => item.isActive === true)
    .map((item) => ({
      label: item[labelKey],
      value: item[valueKey],
    }));
}

export function employeeFormatOptions(
  dataArray,
  labelKey,
  labelKey2 = "",
  valueKey
) {
  if (!Array.isArray(dataArray)) return [];

  return dataArray
    .filter((item) => item.isActive === true)
    .map((item) => ({
      label: `${item[labelKey]} - ${item[labelKey2]}`,
      value: item[valueKey],
    }));
}

export function formatOption2(dataArray, labelKey, valueKey) {
  if (!Array.isArray(dataArray)) return [];

  return (
    dataArray
      // .filter((item) => item.isActive === true)
      .map((item) => ({
        label: item[labelKey],
        value: item[valueKey],
      }))
  );
}

export function formatOptionString(dataArray, labelKey, valueKey) {
  if (!Array.isArray(dataArray)) return [];

  return (
    dataArray
      // .filter((item) => item.isActive === true)
      .map((item) => ({
        label: item[labelKey],
        value: item[valueKey]?.toString(),
      }))
  );
}
